import { useSelector } from "react-redux"
import { selectAuth } from "shared/redux/slices/authSlice"
import { getRoleCode } from "constant/Role"
import { Role } from "constant/Role"
import OrdersWorkspace from "./components/orders/OrdersWorkspace"

const isStaffRole = (roleCode) =>
  roleCode === Role.PROCUREMENT ||
  roleCode === Role.PROCUREMENT_MANAGER ||
  roleCode === Role.PROCUREMENT_STAFF

const MyOrdersContainer = () => {
  const auth = useSelector(selectAuth)
  const roleCode = getRoleCode(auth?.role)
  const staff = isStaffRole(roleCode)
  return (
    // Group Orders is a Procurement/PM capability, not a default every role
    // gets minus an exclusion list — only `staff` roles may see the tab and
    // the "Create Group" action (LXO, and any other non-staff role that ever
    // reaches this page, get the plain single-order flow).
    <OrdersWorkspace
      role={staff ? "manager" : "requester"}
      defaultTab={staff ? "mine" : "all"}
      allowGroupOrders={staff}
    />
  )
}

export default MyOrdersContainer
